import {Button} from "react-aria-components";
import {faBars} from "@fortawesome/pro-regular-svg-icons/faBars";
import clsMerge from "../../../util/clsMerge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const HamburgerMenuButton: typeof Button = ({className, ...props}) => (
	<Button
		className={clsMerge(
			"rounded border border-gray-600 p-3 leading-4 hover:bg-gray-200 focus:bg-gray-200",
			className
		)}
		aria-label="Menu Button"
		{...props}
	>
		<FontAwesomeIcon className="text-gray-800" icon={faBars} aria-hidden />
	</Button>
);

export default HamburgerMenuButton;
